import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject;

import * as React from "react";
import styled from "../../styled-components";
import { MenuItem } from "./MenuItem";
var MenuListStyled = styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  color: ", ";\n  position: relative;\n  a {\n    text-decoration: none;\n    display: block;\n    color: ", ";\n  }\n  .external-url::after {\n    content: none;\n  }\n"])), function (a) {
  return a.theme.sidebar.textColor;
}, function (a) {
  return a.theme.sidebar.textColor;
});
export var MenuItems = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(MenuItems, _React$PureComponent);

  function MenuItems() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = MenuItems.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a = _this$props.depth,
        b = _this$props.items,
        c = _this$props.className,
        d = b.find(function (_ref) {
      var a = _ref.active;
      return a;
    }),
        e = b.find(function (_ref2) {
      var a = _ref2.menuStyle,
          b = _ref2.link;
      return "drilldown" !== a && !!b;
    });
    return /*#__PURE__*/React.createElement(MenuListStyled, {
      depth: a,
      className: c
    }, b.map(function (c, f) {
      var _c$items;

      return /*#__PURE__*/React.createElement(MenuItem, {
        item: c,
        depth: a,
        key: c.pageId + "-" + f,
        isLast: f === b.length - 1,
        activeItem: d,
        firstSiblingItem: e,
        isAlwaysExpanded: "always" === c.expanded
      }, 0 < ((_c$items = c.items) === null || _c$items === void 0 ? void 0 : _c$items.length) ? /*#__PURE__*/React.createElement(MenuItems, {
        items: c.items,
        depth: a + 1
      }) : null);
    }));
  };

  return MenuItems;
}(React.PureComponent);